import { getField } from "vuex-map-fields";

const hasCategory = (state) => state.category !== null;

const selectedFromActiveCategory = (state) => {
  if (state.activeCategoryId in state.selectedAttachables) {
    return state.selectedAttachables[state.activeCategoryId];
  }
  return [];
};

const selectedAttachablesForCategory = (state) => (category) => {
  if (!(category.id in state.selectedAttachables)) return [];
  return state.selectedAttachables[category.id];
};
const hasAttachableInstance = (state) => ({
  id: state.hasAttachableId,
  type: state.hasAttachableType,
});

const activeAttachableCategory = (state) => {
  if (!state.attachableCategories.length || !state.activeAttachableCategoryName) return null;

  return state.attachableCategories
    .find((category) => category.name === state.activeAttachableCategoryName);
};

const categoriesToReload = (state) => {
  const categories = [];
  state.selectedAttachables.forEach((attachable) => {
    if (categories.includes(attachable?.attachable_category_hashed_id)) return;
    categories.push(attachable?.attachable_category_hashed_id);
  });
  return categories;
};
const selectedAttachableIds = (state) => state.selectedAttachables.map((attachable) => attachable.id);
export default {
  selectedAttachableIds,
  hasCategory,
  selectedAttachablesForCategory,
  hasAttachableInstance,
  selectedFromActiveCategory,
  activeAttachableCategory,
  categoriesToReload,
  getField,
};
